import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content wa-msg-modal" }
const _hoisted_4 = { class: "modal-header wa-modal__header" }
const _hoisted_5 = { class: "wa-modal__header-info" }
const _hoisted_6 = { class: "modal-title wa-modal__title" }
const _hoisted_7 = { class: "wa-modal__subtitle" }
const _hoisted_8 = { class: "wa-modal__subtitle-name" }
const _hoisted_9 = { class: "modal-body wa-modal__body" }
const _hoisted_10 = { class: "wa-modal__card" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6 wa-modal__col" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = {
  for: "message-name",
  class: "col-form-label wa-modal__label"
}
const _hoisted_15 = { class: "col-md-6 wa-modal__col" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = {
  for: "message-text",
  class: "col-form-label wa-modal__label"
}
const _hoisted_18 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_19 = {
  for: "description-text",
  class: "col-form-label wa-modal__label"
}
const _hoisted_20 = { class: "wa-modal__toggle-text" }
const _hoisted_21 = { class: "wa-modal__toggle-title" }
const _hoisted_22 = { class: "wa-modal__toggle-hint" }
const _hoisted_23 = { class: "modal-footer wa-modal__footer" }
const _hoisted_24 = { class: "wa-modal__footer-hint" }
const _hoisted_25 = { class: "wa-modal__footer-actions" }
const _hoisted_26 = {
  type: "button",
  class: "wa-modal__btn-close-text",
  "data-bs-dismiss": "modal"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_29 = {
  key: 1,
  class: "fas fa-paper-plane me-2"
}

import {ref, Ref, onMounted, watch} from 'vue'
import SettingsRepository from '@/repositories/SettingsRepository'
import ToastService from '@/services/ToastService'
import { SettingsMessageInterface } from '@/types/SettingsMessagesInterface'
import { hide } from '@/helpers/ModalHelper'
import i18n from '@/plugins/i18n'
import InteractiveMessageBuilder from '@/components/InteractiveMessageBuilder.vue'
import TextEditor from '@/components/TextEditor.vue'
import WhatsAppPhonePreview from '@/components/WhatsAppPhonePreview.vue'
import { Interactive } from '@/types/Interactive'


export default /*@__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    selectedMessage: {}
  },
  emits: ['updateMessages'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const textArea = ref<HTMLTextAreaElement | null>(null)
const text = ref<string>('')
const formattedMessage = ref<string>('')
const emit = __emit
const isInteractiveMessage = ref<boolean>(false)
const interactiveMessage = ref<Interactive|null>(null)
const submitting = ref(false)

function updateFormattedMessage(text: string): void{
  formattedMessage.value = text
}

function updateMessage(content: string): void {
  text.value = content
}

function updateInteractiveMessage(message: Interactive|null): void {
  interactiveMessage.value = message
}

function updateTextareaDescription() {
  const textarea = textArea.value
  if (textarea) {
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight}px`
  }
}

function toggleInteractiveMessage(): void {
  isInteractiveMessage.value = !isInteractiveMessage.value
  if (!isInteractiveMessage.value) {
    interactiveMessage.value = null
  } else {
    interactiveMessage.value = {
      type: 'button',
      body: { text: text.value },
      action: {
        buttons: [],
      },
    }
  }
}

function saveChanges(): void {
  if (!props.selectedMessage.message && text.value == '') return
  submitting.value = true
  const updatedMessage = {
    id: props.selectedMessage.id,
    name: props.selectedMessage.name,
    description: props.selectedMessage.description,
    message: text.value,
    enabled: props.selectedMessage.enabled,
    interactive: interactiveMessage.value,
  }

  SettingsRepository.updateMessage(updatedMessage).then(async () => {
    emit('updateMessages')
    submitting.value = false
    hide(updatedMessage.id)
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    submitting.value = false
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

onMounted(() => {
  isInteractiveMessage.value = props.selectedMessage.interactive != undefined
  text.value = props.selectedMessage.message
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.selectedMessage.id,
    class: "modal fade",
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wa-modal__icon-chip" }, [
              _createElementVNode("em", { class: "fa-brands fa-whatsapp" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('wp.modal.title')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t('wp.modal.subtitle')) + " · ", 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$props.selectedMessage.name || '—'), 1)
              ])
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("button", {
            type: "button",
            class: "wa-modal__close-btn",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("em", { class: "fas fa-xmark" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('common.fields.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    ref: "inputName",
                    name: "message-name",
                    class: "wa-modal__input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$props.selectedMessage.name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.$props.selectedMessage.name]
                  ])
                ]),
                _createVNode(TextEditor, {
                  selectedMessage: _ctx.$props.selectedMessage.message,
                  onMessageUpdated: updateMessage,
                  onContentUpdated: updateFormattedMessage
                }, null, 8, ["selectedMessage"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('common.fields.label_preview')), 1),
                  _createVNode(WhatsAppPhonePreview, { "formatted-message": formattedMessage.value }, null, 8, ["formatted-message"])
                ]),
                (_ctx.$props.selectedMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('common.fields.label_description')), 1),
                      _withDirectives(_createElementVNode("textarea", {
                        class: "text-area-Description wa-modal__input wa-modal__textarea",
                        id: "description-text",
                        "aria-label": "Description",
                        "aria-describedby": "description-addon",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$props.selectedMessage.description) = $event)),
                        rows: "5",
                        onInput: updateTextareaDescription
                      }, null, 544), [
                        [_vModelText, _ctx.$props.selectedMessage.description]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["wa-modal__toggle", { 'wa-modal__toggle--on': isInteractiveMessage.value }]),
            onClick: toggleInteractiveMessage
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "wa-modal__toggle-icon" }, [
              _createElementVNode("em", { class: "fas fa-bolt" })
            ], -1)),
            _createElementVNode("span", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(isInteractiveMessage.value ? _ctx.$t('wp.modal.interactive_enabled_title') : _ctx.$t('wp.modal.interactive_disabled_title')), 1),
              _createElementVNode("span", _hoisted_22, _toDisplayString(isInteractiveMessage.value ? _ctx.$t('wp.modal.interactive_enabled_hint') : _ctx.$t('wp.modal.interactive_disabled_hint')), 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "wa-modal__switch" }, [
              _createElementVNode("span", { class: "wa-modal__switch-knob" })
            ], -1))
          ], 2),
          (isInteractiveMessage.value)
            ? (_openBlock(), _createBlock(InteractiveMessageBuilder, {
                key: 0,
                onInteractiveUpdated: updateInteractiveMessage,
                selectedInteractive: _ctx.$props.selectedMessage.interactive
              }, null, 8, ["selectedInteractive"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[6] || (_cache[6] = _createElementVNode("em", { class: "fas fa-circle-info" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('wp.modal.footer_hint')), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.$t('common.actions.close')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "wa-modal__btn-submit",
              onClick: saveChanges,
              disabled: submitting.value
            }, [
              (submitting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                : (_openBlock(), _createElementBlock("em", _hoisted_29)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('wp.modal.save')), 1)
            ], 8, _hoisted_27)
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})